module.exports = __webpack_public_path__ + "media/img/pages/career-starter/01-daadf7b22f224e9f4d9d94b68a700975.png";